import React, { useEffect, useState } from "react";
import ImageOverlay from "../../../components/ImageOverLay/ImageOverlay";
import styles from "./YoutubeUpload.module.css"
import VideoModal from "../../../components/VideoModal/VideoModal";
import { UploadVideo, videosLogic } from "../../../../Logic/Videos";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const YoutubeUpload: React.FC = () => {

    const [video, setVideo] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [viewVideo, setViewVideo] = useState<boolean>(false);
    const [videoAlreadyInDB, setVideoAlreadyInDB] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

    useEffect(() => {
      const func = async () => {
          try 
          {
            //const API_KEY_RTG = "AIzaSyDXEGYWPAv_pw-ceefv9nIySHFm17xISlg";
            const API_KEY = "AIzaSyB5Mq-cNQdatdqeh2MBJdNdtMmaTdNG5jo";
            const CHANNEL_ID = "UCqsIgsmLKRUQTnWlPoqftFA";

            const response = await fetch(
            `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet&type=video&order=date&maxResults=1`
            );
          
            const data = await response.json();
          
            if (data.items && data.items.length > 0) {
              console.log(data.items[0])
              setVideo(data.items[0]); // El primer video es el más nuevo

              await videosLogic.GetVideoFromYoutubeID(data.items[0].id.videoId).then(response => {
                if(response.length > 0)
                  setVideoAlreadyInDB(true);
              })

            } else {
              setError('No videos found.');
            }
          } catch (error) {
              console.log(error)
              setError('No video found.');
          }
      }
      func();
    }, []);

 
    function cleanUtcDate(date: string): string {
      return date.replace('T', ' ').replace('Z', '');
    }

    const uploadVideo = async () => {

      const uploadVideo: UploadVideo =  { 
        title: video.snippet.title,
        url: "https://www.youtube.com/watch?v="+ video.id.videoId ,
        published_at: cleanUtcDate(video.snippet.publishedAt),
        tags: inputValue,
        thumbnail: video.snippet.thumbnails.high.url
      }
 
      await videosLogic.UploadVideo(uploadVideo).then(response => {
        console.log(response);
        setVideoAlreadyInDB(true);
      }).catch(error => {setError("Failed to upload")})
    }

    const showUploadLastVideo = () => {
      if(!videoAlreadyInDB){
        return (
          <>
            <h1>Última prédica</h1>
            <div className={styles.container}>
              {video ? (<>
                  <ImageOverlay
                    src={video.snippet.thumbnails.high.url}
                    alt={video.snippet.title}
                      text="Reproducir"
                      onClick={() => setViewVideo(true)}
                />
                  
                  <label>Tags:</label>
                  <input type="text"  placeholder="Dios,Paz,Pesaj,Familia....." value={inputValue} onChange={handleInputChange}/>
                  <div className={styles.button} onClick={uploadVideo}>
                      Subir Video 
                  </div>
              </>
              ) : (
                error ? null : <p>Cargando video...</p>
              )}

              {error && <p className={styles.errorText}>Error: {error}</p>}
            </div>
          </>
        )
      }else {
        return <><h2>Última prédica subida correctamente <CheckCircleIcon></CheckCircleIcon></h2></>
      }
    }
  
    return (
        <>
          {showUploadLastVideo()}

          {/* Modal para reproducir el video */}
          {viewVideo && <VideoModal videoId={video.id.videoId} onClick={() => setViewVideo(false) }></VideoModal>}
       </>
    )
};

export default YoutubeUpload;
